import React, { Component } from "react";
import { withRouter, HandleLoading, Loading } from "cw-styleguide-react";
import i18n from "../i18n";
import axios from "axios";
import config from "../config";
import Utility from "../utility";
import DetailsView from "../views/DetailsView";

class DetailsController extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animal: null,
      animalLoaded: false,
      messages: new Set(),
    };
  }

  componentDidMount() {
    const slug = this.props.params.id;

    this.props
      .getAnimal(slug)
      .then((response) => {
        console.log("Debug: animal response", response);

        this.setState({
          animal: response.data,
          animalLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Debug: error fetching animal details:", error);
      });
  }

  render() {
    if (this.state.animalLoaded === false) {
      return <Loading text={this.props.t("styleguide:forms.loading")} />;
    }

    return <DetailsView {...this.props} {...this.state} />;
  }
}

export default withRouter(DetailsController);
